<template>
  <div id="LqsAnalyser">
    <div
      data-html2canvas-ignore="true"
      class="customdim"
      v-show="loader || productTableLoader || loaderLastUpdated"
    >
      <Loader />
    </div>
    <div class="">
      <div class="row datepickerwrap card">
        <div class="col-12 p-0">
          <div class="">
            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-start w-75">
                <div style="margin-top: 1.5px">
                  <div class="labelHeading">
                    {{ translatedLang["Date Range"][selectedLanguage.key] }}
                  </div>
                  <date-range-picker
                    v-model="dateRange"
                    opens="right"
                    :autoApply="true"
                    :locale-data="{ format: 'dd mmm yyyy' }"
                    @update="dateChange"
                    style="border: none"
                  >
                  </date-range-picker>
                </div>
                <div
                  class="customMultiselectCommon ml-2 mr-2"
                  style="width: 200px"
                >
                  <div class="labelHeading">
                    {{ translatedLang["Platform"][selectedLanguage.key] }}
                  </div>
                  <multiselect
                    @input="getLastUpdatedDates('changePlatform')"
                    v-model="selectedChannel"
                    :options="storeAllPlatformListData || []"
                    :multiple="false"
                    :searchable="false"
                    placeholder="Select Platform"
                    :showLabels="false"
                    track-by="key"
                    label="value"
                    :close-on-select="true"
                    :allow-empty="false"
                    class="text-capitalize"
                  >
                  </multiselect>
                </div>
                <div class="customMultiselectCommon mr-2" style="width: 180px">
                  <div class="labelHeading">
                    {{ translatedLang["Category"][selectedLanguage.key] }}
                  </div>
                  <multiselect
                    @input="changeLqsCategory()"
                    v-model="selectedCategoryForLqs"
                    :options="[getAllCategoryOption(), ...storeLqsCategory]"
                    :multiple="false"
                    :searchable="false"
                    placeholder="Select Category"
                    track-by="key"
                    label="value"
                    :showLabels="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    class="text-capitalize"
                  >
                  </multiselect>
                </div>
                <div class="">
                  <div class="labelHeading">
                    {{ translatedLang["Product ID/URL"][selectedLanguage.key] }}
                  </div>
                  <div class="">
                    <input
                      style="border: 1px solid var(--base_color-40) !important"
                      class="pl-2"
                      :class="{
                        danger: isInputEmpty,
                        customInput: !isInputEmpty,
                      }"
                      @input="changeInputState"
                      :placeholder="changePlaceholder()"
                      v-model="inputSearchkey"
                      required
                    />
                  </div>
                  <div class="errorMassage" v-if="isInputEmpty">
                    {{
                      translatedLang["Enter Product URL/ASIN/FSN"][
                        selectedLanguage.key
                      ]
                    }}
                  </div>
                </div>
              </div>

              <div class="d-flex align-items-center">
                <button
                  @click="compareAsinIdButtonProduct()"
                  class="btn navigationButton mr-2"
                  v-if="checkButtonVisible()"
                >
                  {{ translatedLang["Compare"][selectedLanguage.key] }}
                </button>
                <div class="">
                  <button
                    class="btn primarycolor"
                    type="button"
                    @click="getLqsListingData"
                  >
                    <span>{{
                      translatedLang["submit"][selectedLanguage.key]
                    }}</span>
                  </button>
                </div>
                <div class="ml-2">
                  <router-link to="/lqs-schedule" style="text-decoration: none">
                    <button class="btn primarycolor scheduleBg" type="button">
                      <span>{{
                        translatedLang["Schedule"][selectedLanguage.key]
                      }}</span>
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <ASINResult/> -->
      <!-- <div v-show="loader">
                <Loader />
            </div> -->

      <div v-if="selectedChannel.key === 'flipkart.com'">
        <div
          class="row px-0"
          id="LqsAnalyserCardFlipkart"
          v-show="viewFlipkartLQSCardData.length != 0"
        >
          <div class="col-md-12 mycols">
            <div class="datepickerwrap mt-0">
              <FlipkartLqsCard
                :viewFSNsDetailedData="viewFlipkartLQSCardData"
                :storeLqsDataByMonthGroup="storeLqsDataByMonthGroup"
                ref="childComp"
                :keyCheck="false"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div
          class="row"
          id="LqsAnalyserCard"
          v-show="viewLqsListingdata.length != 0"
        >
          <div class="col-md-12 mycols">
            <div class="datepickerwrap">
              <LqsCard
                :viewASINsDetailedData="viewLqsListingdata"
                :storeLqsDataByMonthGroup="storeLqsDataByMonthGroup"
                ref="childComp"
                :keyCheck="false"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- products list -->
      <!-- <MyProducts :dateRangeProduct="dateRange" :selectedChannel="selectedChannel" ref="childProductComp"
                @updateCheckButtonVisibility="updateButtonVisibility"
                :selectedCategoryForLqs="selectedCategoryForLqs" /> -->

      <!-- product new list  -->
      <div id="MyProducts">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 mt-0">
              <div class="card productBorder">
                <div
                  class="productNameHeading pb-2 d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex justify-content-start align-items-center">
                    <h3 class="mb-0 mr-2">
                      {{ translatedLang["Products"][selectedLanguage.key] }}
                    </h3>
                    <div style="width: 17px">
                      <img
                        style="cursor: pointer"
                        src="../../../public/Icons_SVG/infoIcon.svg"
                        class="w-100"
                        title="product List"
                      />
                    </div>
                    <!-- <i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2" aria-hidden="true"
                                            title="products"></i> -->
                  </div>
                </div>
                <div
                  class="mt-3"
                  v-if="viewMyASINsData.data && asinProductTableDataShow"
                >
                  <table
                    class="table selectable"
                    id="MyasinTable"
                    style="width: 100%; overflow: hidden"
                  >
                    <thead class="thead-normal">
                      <tr>
                        <th
                          width="1%"
                          class="checkbox-select"
                          v-if="viewMyASINsData.data"
                        >
                          {{ translatedLang["Select"][selectedLanguage.key] }}
                        </th>
                        <th
                          style="padding: 10px 0 !important"
                          scope="col"
                          v-for="th of viewMyASINsData.header"
                          :key="th.key"
                          class="p-2"
                        >
                          {{ th.lable }}
                        </th>
                        <th>
                          {{ translatedLang["Actions"][selectedLanguage.key] }}
                        </th>
                      </tr>
                    </thead>
                    <tbody class="tbody-normal">
                      <tr
                        v-for="(row, i) in viewMyASINsData.data"
                        :key="i"
                        :class="[
                          {
                            unblur:
                              storeShowBreakdownIndex === i &&
                              showBreakdownModalValue,
                            blur:
                              storeShowBreakdownIndex !== i &&
                              i !== null &&
                              showBreakdownModalValue,
                          },
                        ]"
                        @mouseenter="
                          showBreakdownModalFun('mousein', row, i, $event)
                        "
                        @mouseleave="
                          showBreakdownModalFun('mouseout', row, i, $event)
                        "
                      >
                        <td width="1%" class="checkbox-none checkbox-asin">
                          <input
                            @click="setIndex(row, i)"
                            type="checkbox"
                            name=""
                            id=""
                          />
                        </td>
                        <td
                          v-for="(d, j) in viewMyASINsData.header"
                          :key="j"
                          :style="[
                            d.key == 'product_name'
                              ? { width: '25%' }
                              : { width: '10%' },
                          ]"
                        >
                          <!-- <router-link :to="'/asins-detailed/' +
												row.product_asin +
												'/' +
												dateRange.startDate +
												'/' +
												dateRange.endDate
												" v-if="d.key == 'product_asin'"> -->
                          <div
                            style="text-transform: capitalize"
                            v-if="d.key == 'product_asin'"
                          >
                            {{ row[d.key] }}
                          </div>
                          <!-- </router-link> -->
                          <!-- <router-link :to="'/fsns-detailed/' +
												row.product_fsn +
												'/' +
												dateRange.startDate +
												'/' +
												dateRange.endDate
												" v-else-if="d.key == 'product_fsn'"> -->
                          <div
                            style="text-transform: capitalize"
                            v-else-if="d.key == 'product_fsn'"
                          >
                            {{ row[d.key] }}
                          </div>
                          <!-- </router-link> -->
                          <!--product image -->
                          <a
                            :href="row.product_link"
                            target="_blanck"
                            v-else-if="d.key == 'product_image'"
                            style="display: flex; justify-content: center"
                          >
                            <div
                              class="rounded"
                              style="
                                width: 100px;
                                text-transform: capitalize;
                                background: linear-gradient(
                                  180deg,
                                  rgba(0, 0, 0, 0.05) 0%,
                                  rgba(255, 255, 255, 0) 100%
                                );
                                border: 1px solid #ebebeb;
                              "
                            >
                              <img
                                :src="row[d.key]"
                                style="
                                  width: 100%;
                                  mix-blend-mode: multiply;
                                  padding: 10px;
                                "
                              />
                            </div>
                          </a>
                          <a
                            :href="row.product_link"
                            target="_blanck"
                            v-else-if="d.key == 'product_name'"
                            class="productName"
                          >
                            <div
                              style="
                                text-transform: capitalize;
                                color: '#000000';
                              "
                              :class="[
                                {
                                  unblur:
                                    storeShowBreakdownIndex === i &&
                                    showBreakdownModalValue,
                                  blur:
                                    storeShowBreakdownIndex !== i &&
                                    i !== null &&
                                    showBreakdownModalValue,
                                },
                              ]"
                            >
                              {{ row[d.key] }}
                            </div>
                          </a>
                          <div v-else-if="d.key == 'timestamp'">
                            {{ row[d.key].split(",")[0] }}<br />{{
                              row[d.key].split(",")[1]
                            }}
                            <span>,{{ row[d.key].split(",")[2] }}</span>
                          </div>
                          <div v-else>
                            {{ row[d.key] }}
                          </div>
                        </td>
                        <td style="width: 12%">
                          <div
                            class="d-flex justify-content-center align-items-center"
                          >
                            <router-link
                              v-if="row.product_asin"
                              :to="
                                '/asins-detailed/'+row.website+'/'+
                                row.product_asin +
                                '/' +
                                dateRange.startDate +
                                '/' +
                                dateRange.endDate
                              "
                            >
                              <button
                                class="btn mr-3"
                                :class="[
                                  (storeShowBreakdownIndex === i &&
                                    showBreakdownModalValue) ||
                                  checkboxIndices.includes(i)
                                    ? 'primarycolorShow'
                                    : 'primarycolorShow primarycolorShow2',
                                ]"
                              >
                                {{
                                  translatedLang["Show Details"][
                                    selectedLanguage.key
                                  ]
                                }}
                              </button>
                            </router-link>
                            <router-link
                              v-if="row.product_fsn"
                              :to="
                                '/fsns-detailed/' +
                                row.product_fsn +
                                '/' +
                                dateRange.startDate +
                                '/' +
                                dateRange.endDate
                              "
                            >
                              <button
                                class="btn mr-3"
                                :class="[
                                  (storeShowBreakdownIndex === i &&
                                    showBreakdownModalValue) ||
                                  checkboxIndices.includes(i)
                                    ? 'primarycolorShow'
                                    : 'primarycolorShow primarycolorShow2',
                                ]"
                              >
                                {{
                                  translatedLang["Show Details"][
                                    selectedLanguage.key
                                  ]
                                }}
                              </button>
                            </router-link>
                            <div
                              class="deleteProductBtnContainer"
                              @click="
                                confirmDeleteProductsRow(
                                  row.product_asin
                                    ? row.product_asin
                                    : row.product_fsn
                                    ? row.product_fsn
                                    : null,
                                  row.website
                                )
                              "
                            >
                              <b-button variant="outline-danger"
                                ><i class="fa fa-trash"
                              /></b-button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  v-else-if="!asinProductTableDataShow && productTableLoader"
                  class="onLoadingData mt-3"
                >
                  {{ translatedLang["Loading"][selectedLanguage.key] }}...
                </div>
                <div
                  v-else
                  class="text-danger d-flex justify-content-center border border-danger rounded mt-3 noData"
                >
                  {{
                    translatedLang["No Data Available"][selectedLanguage.key]
                  }}.
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-modal
          title="Delete LQS Product"
          v-model="deleteProductRowModal"
          class="container-modal-ASIN"
        >
          <div class="modal-delete-content d-flex align-items-start mb-2">
            <div class="delete-alert text-center rounded-circle px-2 mr-3">
              &#9888;
            </div>
            <div>
              {{ translatedLang["delete this product"][selectedLanguage.key]
              }}<br />{{ translatedLang["Are you sure"][selectedLanguage.key] }}
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <b-button @click="closeConfirmRowModal" class="btn primarycolor"
              >{{ translatedLang["No"][selectedLanguage.key] }},
              {{ translatedLang["Keep It"][selectedLanguage.key] }}.</b-button
            >
            <button
              class="btn primarycolor px-3 py-1 ml-2 d-flex align-items-center delete-requestBtn"
              style="background-color: var(--red)"
              @click="deleteLQSProductApi()"
              :disabled="disableDeleteProductBtn"
            >
              <b-spinner
                small
                class="mr-2"
                v-if="deleteProductLoader"
              ></b-spinner>
              <span
                >{{ translatedLang["Yes"][selectedLanguage.key] }},
                {{ translatedLang["Delete"][selectedLanguage.key] }}!</span
              >
            </button>
          </div>
        </b-modal>
        <div
          title=""
          v-if="showBreakdownModalValue"
          class="container-breakdown-ASIN"
          :style="popupStyles"
        >
          <div class="modal-delete-content d-flex align-items-stretch mb-2">
            <div class="copyBrekdownData px-5 mt-3 customWidth-33">
              <div class="d-flex align-items-center">
                <p
                  style="width: 10px; height: 10px; background-color: #33aba0"
                  class="rounded mr-2"
                ></p>
                <p>
                  {{ translatedLang["Copy Breakdown"][selectedLanguage.key] }}
                </p>
              </div>
              <div
                v-if="
                  storeBreakdownDataInModal.copy_breakdown &&
                  storeBreakdownDataInModal.copy_breakdown.length
                "
              >
                <div
                  class="d-flex justify-content-start align-items-center pb-3 pl-0 pr-0"
                  v-for="items in storeBreakdownDataInModal.copy_breakdown"
                >
                  <div
                    :class="[
                      items.status ? 'breakdownLables' : 'breakdownLablesRed',
                    ]"
                  >
                    <div class="d-flex align-items-center">
                      <h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">
                        {{ items.label }}
                      </h5>
                    </div>
                    <p class="mb-0" v-if="Array.isArray(items.current)">
                      {{ translatedLang["Current"][selectedLanguage.key] }} :
                      {{ items.current.join(", ") }}
                    </p>
                    <p class="mb-0" v-else-if="items.current">
                      {{ translatedLang["Current"][selectedLanguage.key] }} :
                      {{ items.current }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="d-flex justify-content-start align-items-center noDataBreak"
              >
                <img
                  src="../../../public/Icons_SVG/lqsNoIsueMsg.png"
                  style="max-height: 31px"
                />
              </div>
            </div>
            <div class="mediaBreakdownData px-5 mt-3 customWidth-33">
              <div class="d-flex align-items-center">
                <p
                  style="width: 10px; height: 10px; background-color: #8778ea"
                  class="rounded mr-2"
                ></p>
                <p>
                  {{ translatedLang["Media Breakdown"][selectedLanguage.key] }}
                </p>
              </div>
              <div
                v-if="
                  storeBreakdownDataInModal.media_breakdown &&
                  storeBreakdownDataInModal.media_breakdown.length
                "
              >
                <div
                  class="d-flex justify-content-start align-items-center pb-3 pl-0 pr-0"
                  v-for="items in storeBreakdownDataInModal.media_breakdown"
                >
                  <div
                    :class="[
                      items.status ? 'breakdownLables' : 'breakdownLablesRed',
                    ]"
                  >
                    <div class="d-flex align-items-center">
                      <h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">
                        {{ items.label }}
                      </h5>
                    </div>
                    <p class="mb-0" v-if="Array.isArray(items.current)">
                      Current : {{ items.current.join(", ") }}
                    </p>
                    <p class="mb-0" v-else-if="items.current">
                      Current : {{ items.current }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="d-flex justify-content-start align-items-center noDataBreak"
              >
                <img
                  src="../../../public/Icons_SVG/lqsNoIsueMsg.png"
                  style="max-height: 31px"
                />
              </div>
            </div>
            <div class="reviewBreakdownData px-5 mt-3 customWidth-33">
              <div class="d-flex align-items-center">
                <p
                  style="width: 10px; height: 10px; background-color: #fd5542"
                  class="rounded mr-2"
                ></p>
                <p>
                  {{ translatedLang["Review Breakdown"][selectedLanguage.key] }}
                </p>
              </div>
              <div
                v-if="
                  storeBreakdownDataInModal.review_breakdown &&
                  storeBreakdownDataInModal.review_breakdown.length
                "
              >
                <div
                  class="d-flex justify-content-start align-items-center pb-3 pl-0 pr-0"
                  v-for="items in storeBreakdownDataInModal.review_breakdown"
                >
                  <div
                    :class="[
                      items.status ? 'breakdownLables' : 'breakdownLablesRed',
                    ]"
                  >
                    <div class="d-flex align-items-center">
                      <h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">
                        {{ items.label }}
                      </h5>
                    </div>
                    <p class="mb-0" v-if="Array.isArray(items.current)">
                      {{ translatedLang["Current"][selectedLanguage.key] }} :
                      {{ items.current.join(", ") }}
                    </p>
                    <p class="mb-0" v-else-if="items.current">
                      {{ translatedLang["Current"][selectedLanguage.key] }} :
                      {{ items.current }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="d-flex justify-content-start align-items-center noDataBreak"
              >
                <img
                  src="../../../public/Icons_SVG/lqsNoIsueMsg.png"
                  style="max-height: 31px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LqsCard from "./LqsCard";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
// import MyProducts from "./MyProducts.vue";
import FlipkartLqsCard from "./Flipkart/FlipkartLqsCard.vue";
import Loader from "../Components/Loader.vue";
import Multiselect from "vue-multiselect";
import { mapState, mapActions } from "vuex";

export default {
  name: "LqsAnalyser",
  components: { Loader, LqsCard, Multiselect, Datepicker, FlipkartLqsCard },

  data: function () {
    return {
      gaugeChartData: {}, // correct
      viewLqsListingdata: [], // correct
      storeAllPlatformListData: [], // correct
      inputSearchkey: "", // correct
      viewLqsGraph: "", // correct
      loader: false, // correct
      productTableLoader: true,
      loaderLastUpdated: false,
      asin: "", // correct
      fsn: "", // correct
      isInputEmpty: false, // correct
      // isMyASINDataOpen: false,
      schedule: {
        email: "",
        ASIN: "",
        ASINs: [],
        requestName: "",
      },
      // viewMyASINsData: {},
      // viewLqsRequestData: { data: [] },
      dateRange: {
        startDate: moment().subtract(1, "month"),
        endDate: moment(),
      },
      selectedChannel:
        sessionStorage.getItem("productSelectedChannel") == null
          ? { key: "amazon.in", value: "Amazon Retail" }
          : sessionStorage.getItem("productSelectedChannel"), // correct
      selectedChannelForScheule: { key: "amazon.in", value: "Amazon Retail" },
      selectedReqChannel: { key: "amazon.in", value: "Amazon Retail" },
      intervalId: null,
      deleteRequestModal: false,
      storeDeleteRequestId: [],
      deleteRequestLoader: false,
      customClient: JSON.parse(localStorage.reviewUserData).data.client,
      viewFlipkartLQSCardData: [],
      storeLqsDataByMonthGroup: null,
      totalCountValue: null,
      showCompareButton: false,
      storeLqsCategory: [],
      selectedCategoryForLqs:
        sessionStorage.getItem("lqsCategoryValue") == null ||
        JSON.parse(sessionStorage.getItem("lqsCategoryValue")).key == ""
          ? this.getAllCategoryOption()
          : {
              key: JSON.parse(sessionStorage.getItem("lqsCategoryValue")).key,
              value: JSON.parse(sessionStorage.getItem("lqsCategoryValue"))
                .value,
            },
      platformMapping: {
        "amazon.in": "Amazon Retail",
        "amazon.com": "Amazon US",
        "flipkart.com": "Flipkart",
        "amazon.ae": "Amazon Retail Uae",
        "myntra.com": "Myntra",
      },
      viewCategoryList: "",

      viewMyASINsData: {}, // correct
      compareAsinIds: [], // correct
      deleteProductRowModal: false, // correct
      deleteProductLoader: false, // correct
      disableDeleteProductBtn: false, // correct
      checkboxIndices: [], // correct
      storeDeleteProductId: "", // correct
      storeDeleteChannelName: "", // correct
      showBreakdownModalValue: false, // correct
      storeShowBreakdownIndex: null, // correct
      storeBreakdownDataInModal: {}, // correct
      popupStyles: {
        // correct
        position: "absolute",
        top: "0px",
        left: "0px",
        zIndex: "9999",
      },

      asinProductTableDataShow: false, // correct
    };
  },

  mounted() {
    this.dataAPIs();
    this.$store.dispatch("DemoStore/setUpdatedStatus", "");
  },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
    getLastUpdatedDates(checkValue) {
      this.loaderLastUpdated = true;
      const url = "/api/v2/spider/lqs_last_update";
      const payload = {
        client: this.customClient,
        channel: this.selectedChannel.key,
        // language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          if (response.body.data.data) {
            const input = response.body.data.data;
            const [date, time] = input.split(" ");
            this.dateRange.endDate = moment(date).format("YYYY-MM-DD");
            this.dateRange.startDate = moment(date)
              .subtract(1, "month")
              .format("YYYY-MM-DD");
            this.lastUpdated = `${moment(date).format("DD MMM, YYYY")} ${
              response.body.data.data ? "at" : ""
            } ${moment(time, "HH:mm:ss").format("hh:mm A")}`;
            this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);
            this.formatDates();
          } else {
            this.dateRange.endDate = moment().format("YYYY-MM-DD");
            this.dateRange.startDate = moment()
              .subtract(1, "month")
              .format("YYYY-MM-DD");
            this.$store.dispatch("DemoStore/setTimeStamp", "");
            this.formatDates();
          }
          if (checkValue == "changePlatform") {
            this.processCategoryData();
            this.selectedCategoryForLqs = this.getAllCategoryOption();
            sessionStorage.setItem(
              "productSelectedChannel",
              JSON.stringify(this.selectedChannel)
            );
            this.changeTableData();
          } else if (checkValue == "firstRender") {
            this.selectedCategoryForLqs = this.getAllCategoryOption();
            this.getAllLqsCategory();
          }

          // this.processCategoryData();
          this.loaderLastUpdated = false;
        })
        .catch((err) => {
          this.loaderLastUpdated = false;
          console.log("err", err);
        });
    },

    dataAPIs() {
      this.getAllPlatformsListByApi();
    },
    formatDates() {
      this.dateRange.startDate = moment(this.dateRange.startDate).format(
        "YYYY-MM-DD"
      );
      this.dateRange.endDate = moment(this.dateRange.endDate).format(
        "YYYY-MM-DD"
      );
    },

    dateChange() {
      this.formatDates();
      (this.viewFlipkartLQSCardData = []), (this.viewLqsListingdata = []);
      (this.checkboxIndices = []), (this.compareAsinIds = []);
      this.changeTableData();
    },

    // updateSelectedLabels(value) {
    //     return `www.${value}`
    // },

    getAllLqsCategory() {
      let self = this;
      let url = "/api/v2/spider/lqscategory";
      (self.storeLqsCategory = ""), (self.viewCategoryList = "");
      let payload = {
        client: this.customClient,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      self.$http
        .post(url, payload)
        .then((res) => {
          // console.log(res, 'enter');
          self.viewCategoryList = res.body.data.data;
          this.processCategoryData();
          this.getMyASINsData();
        })
        .catch((err) => {
          console.log(err, "lqs category error Massage");
        });
    },

    getAllPlatformsListByApi() {
      let self = this;
      let url = "/api/v2/region/platform_list";
      self.storeAllPlatformListData = [];
      let payload = {
        client: this.customClient,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      self.$http
        .post(url, payload)
        .then((res) => {
          if (res.body.data && Array.isArray(res.body.data)) {
            this.storeAllPlatformListData = res.body.data;
            this.updateChannelSelections();
            localStorage.setItem(
              "storeAllPlatformListDataForLqs",
              JSON.stringify(this.storeAllPlatformListData)
            );
          }
          this.getLastUpdatedDates("firstRender");
        })
        .catch((err) => {
          console.log(err, "platforms error Massage");
        });
    },

    updateChannelSelections() {
      this.selectedChannel = JSON.parse(
        sessionStorage.getItem("productSelectedChannel")
      ) ||
        this.storeAllPlatformListData[0] || {
          key: "amazon.in",
          value: "Amazon Retail",
        };
      this.selectedChannelForScheule = this.storeAllPlatformListData[0] || {
        key: "amazon.in",
        value: "Amazon Retail",
      };
      this.selectedReqChannel = this.storeAllPlatformListData[0] || {
        key: "amazon.in",
        value: "Amazon Retail",
      };
    },

    processCategoryData() {
      const platformKey = this.selectedChannel && this.selectedChannel.key;
      const categoryKey = platformKey && this.platformMapping[platformKey];

      if (
        categoryKey &&
        this.viewCategoryList &&
        this.viewCategoryList[categoryKey]
      ) {
        this.storeLqsCategory = this.viewCategoryList[categoryKey];
      } else {
        this.storeLqsCategory = [];
      }
    },

    changeTableData() {
      $("#MyasinTable").DataTable().destroy();
      this.getMyASINsData();
    },

    changePlaceholder() {
      let temp = "Enter Product ";
      temp +=
        this.selectedChannel.key == "flipkart.com" ? "ID or URL" : "ID or URL";
      return temp;
    },

    // changeSchedulePlaceholder() {
    //     const ASIN = 'Enter ASIN (press enter for multiple ASINs)'
    //     const FSN = 'Enter FSN (press enter for multiple FSNs)'
    //     return (this.selectedChannelForScheule.key == 'flipkart.com' ? FSN : ASIN)
    // },

    // addASIN() {
    //     let data = this.schedule.ASIN.trim();
    //     if (event.key != "Enter" || !data.length) {
    //         return false;
    //     }
    //     if (this.selectedChannelForScheule.key == 'flipkart.com') {
    //         if (data.length != 16) {
    //             alert("Please enter vaild FSN");
    //             return false
    //         }
    //         if (!this.schedule.ASINs.includes(data)) {
    //             this.schedule.ASINs.push(data);
    //             this.schedule.ASIN = "";
    //         }
    //         else {
    //             alert("Please enter different FSN")
    //         }
    //     }
    //     else {
    //         if (!this.validASIN(data)) {
    //             alert("please enter vaild ASIN");
    //             return false
    //         }
    //         if (!this.schedule.ASINs.includes(data)) {
    //             this.schedule.ASINs.push(data);
    //             this.schedule.ASIN = "";
    //         }
    //         else {
    //             alert("Please enter different ASIN")
    //         }
    //     }
    // },

    // addASINButton() {
    //     let data = this.schedule.ASIN.trim();
    //     if (this.selectedChannelForScheule.key == 'flipkart.com') {
    //         if (data.length != 16) {
    //             alert("Please enter vaild FSN");
    //             return false
    //         }
    //         if (!this.schedule.ASINs.includes(data)) {
    //             this.schedule.ASINs.push(data);
    //             this.schedule.ASIN = "";
    //         }
    //         else {
    //             alert("Please enter different FSN")
    //         }
    //     }
    //     else {
    //         if (!this.validASIN(data)) {
    //             alert("please enter vaild ASIN");
    //             return false
    //         }
    //         if (!this.schedule.ASINs.includes(data)) {
    //             this.schedule.ASINs.push(data);
    //             this.schedule.ASIN = "";
    //         }
    //         else {
    //             alert("Please enter different ASIN")
    //         }
    //     }
    // },
    // removeASIN(i) {
    //     this.schedule.ASINs.splice(i, 1);
    // },

    // delete ASIN request
    // confirmDeleteRequestASIN(reqId) {
    //     this.storeDeleteRequestId = []
    //     this.storeDeleteRequestId.push(reqId);
    //     this.deleteRequestModal = true;
    // },

    // closeConfirmModal() {
    //     this.storeDeleteRequestId = []
    //     this.deleteRequestModal = false;
    // },

    // deleteRequestASIN() {
    //     // pending
    //     let self = this;
    //     self.loader = false;
    //     self.deleteRequestLoader = true
    //     let payload = {
    //         job_ids: this.storeDeleteRequestId
    //     };
    //     const url = "/api/v2/spider/deleterequests";
    //     self.$http
    //         .post(url, payload)
    //         .then((response) => {
    //             self.deleteRequestLoader = false;
    //             this.deleteRequestModal = false;
    //             self.getLqsRequest(false);
    //             self.storeDeleteRequestId = []
    //             self.loader = false;
    //             this.$bvToast.toast(response.data.data.message, {
    //                 title: response.data.data.summary,
    //                 autoHideDelay: 3000,
    //                 variant: "success"
    //             });
    //         })
    //         .catch((err) => {
    //             self.loader = false;
    //             console.log("err");
    //         });
    // },

    // imp
    changeInputState() {
      this.isInputEmpty = false;
    },

    // async takeScreenshot() {
    //     let self = this
    //     let id = "#LqsAnalyserCard";
    //     let uniqueCardId = document.querySelector(id);
    //     let getScreenshotDiv = uniqueCardId.querySelector('.screenshot-btn');
    //     getScreenshotDiv.classList.add('screenshot-hide-btn');
    //     html2canvas(uniqueCardId, { useCORS: true }).then(function (canvas) {
    //         canvas.style.display = "none"
    //         document.body.appendChild(canvas);
    //         const image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
    //         const a = document.createElement("a");
    //         a.setAttribute("download", `Weavr-LQS-${self.asinData}.png`);
    //         a.setAttribute("href", image);
    //         a.click();
    //         getScreenshotDiv.classList.remove('screenshot-hide-btn');
    //     });
    // },
    // getLqsRequest(loader) {
    //     let self = this;
    //     self.loader = loader;
    //     let payload = {
    //         start: this.dateRange.startDate,
    //         end: this.dateRange.endDate,
    //         client: this.customClient,
    //         channel: this.selectedReqChannel,
    //     };
    //     const url = "/api/v2/spider/viewrequest";
    //     self.$http
    //         .post(url, payload)
    //         .then((response) => {
    //             // if(Object.keys(response.data.data.data).length)
    //             self.loader = false;
    //             self.viewLqsRequestData = response.data.data;
    //             self.destroyInterval();
    //         })
    //         .catch((err) => {
    //             this.$bvToast.toast(response.data.data.message, {
    //                 title: response.data.data.summary,
    //                 autoHideDelay: 3000,
    //                 variant: "warning"
    //             });
    //             self.loader = false;
    //             console.log("err");
    //         });
    // },

    // postLqsBulkSchedule() {
    //     let self = this;
    //     this.loader = true
    //     if (!this.schedule.requestName) {
    //         alert("Enter request name");
    //         return false

    //     }
    //     if (!this.validEmail(this.schedule.email) || !this.schedule.email) {
    //         alert("E-mail id incorrect");
    //         return false;
    //     }

    //     if (this.schedule.ASIN) {
    //         if (this.selectedChannelForScheule.key == 'flipkart.com') {
    //             if (this.schedule.ASIN.length != 16) {

    //                 alert("Please enter vaild FSN");
    //                 return false
    //             }
    //             else {
    //                 this.schedule.ASINs.push(this.schedule.ASIN);
    //             }
    //         }
    //         else {
    //             if (this.validASIN(this.schedule.ASIN)) {
    //                 if (!this.schedule.ASINs.includes(this.schedule.ASIN)) {
    //                     this.schedule.ASINs.push(this.schedule.ASIN);
    //                 }
    //             } else {
    //                 alert("Please enter vaild ASIN");
    //                 return false
    //             }
    //             if (!this.validASIN(this.schedule.ASIN) && this.schedule.ASINs.length == 0) {
    //                 alert("Please enter vaild ASIN");
    //                 return false
    //             }
    //         }
    //     }

    //     let payload = {
    //         email: self.schedule.email,
    //         client: self.customClient,
    //         request_name: self.schedule.requestName,
    //         channel: self.selectedChannelForScheule.key,
    //     };

    //     let url = "";
    //     if (this.selectedChannelForScheule == 'flipkart.com') {
    //         url = "api/v2/spider/flipkart_lqs_request_bulk"
    //         payload.fsn_id = self.schedule.ASINs
    //     }
    //     else {
    //         url = '/api/v2/spider/lqsscheduler'
    //         payload.asin_id = self.schedule.ASINs
    //     }

    //     self.$http
    //         .post(url, payload)
    //         .then((response) => {

    //             self.schedule.ASIN = '',
    //                 self.schedule.requestName = ''
    //             self.schedule.ASINs = [];
    //             self.schedule.email = [];

    //             self.loader = false;
    //             alert("Success");
    //         })
    //         .catch((err) => {
    //             self.loader = false;
    //             console.log("err");
    //         });
    // },
    // imp
    // validEmail(email) {
    //     var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //     return re.test(email);
    // },

    // imp
    validASIN(ASIN) {
      var isASIN = /^[A-Z0-9]{10}$/;
      return isASIN.test(ASIN);
    },

    validMyntraProductId(productId) {
      return /^\d+$/.test(productId);
    },

    // imp
    isValidURL(url) {
      const regex =
        /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
      return regex.test(url);
    },

    // imp
    getPidFromUrl(url) {
      // Create a URL object from the input URL
      const urlObj = new URL(url);
      // Use URLSearchParams to get the value of the 'pid' parameter
      const params = new URLSearchParams(urlObj.search);
      const pid = params.get("pid");

      // Return the pid value
      return pid;
    },

    getMyntraProductIdFromUrl(url) {
      const match = url.match(/\/(\d+)(?:\/|$|\?)/);
      if (match && match.length > 1) {
        return match[1];
      }
      return false;
    },

    // imp
    getASINFromUrl(url) {
      const asinRegex = /\/([A-Z0-9]{10})(?:[/?]|$)/i;
      const match = url.match(asinRegex);
      if (match && match.length > 1) {
        return match[1];
      }
      return false;
    },

    // important
    getLqsListingData() {
      let self = this;
      let tempInputSearchKey = this.inputSearchkey;
      if (!this.inputSearchkey) {
        self.isInputEmpty = true;
        return false;
      }

      if (this.selectedChannel.key == "flipkart.com") {
        if (this.isValidURL(this.inputSearchkey)) {
          tempInputSearchKey = this.getPidFromUrl(this.inputSearchkey);
        } else if (this.inputSearchkey.length != 16) {
          alert("Please enter vaild FSN");
          return false;
        } else {
          // alert("Please enter valid product URL/FSN")
        }
      } else if (this.selectedChannel.key == "myntra.com") {
        if (this.isValidURL(this.inputSearchkey)) {
          tempInputSearchKey = this.getMyntraProductIdFromUrl(
            this.inputSearchkey
          );
          if (!tempInputSearchKey) {
            alert("Please enter vaild Myntra Product ID");
            return false;
          }
        } else if (!this.validMyntraProductId(this.inputSearchkey)) {
          alert("Please enter vaild Myntra Product ID");
          return false;
        } else {
          // alert("Please enter valid product URL/Product ID")
        }
      } else {
        if (this.isValidURL(this.inputSearchkey)) {
           tempInputSearchKey = this.getASINFromUrl(this.inputSearchkey);
        } else if (!this.validASIN(this.inputSearchkey)) {
          alert("Please enter vaild ASIN");
          return false;
        } else {
          // alert("Please enter valid product URL/ASIN")
        }
      }
      self.loader = true;
      self.viewLqsListingdata = [];
      self.viewLqsGraph = "";
      self.viewFlipkartLQSCardData = [];
      self.asin = tempInputSearchKey;
      self.fsn = tempInputSearchKey;
      let payload = {
        client: self.customClient,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };

      let url = "";

      if (self.selectedChannel.key != "flipkart.com") {
        payload.channel = self.selectedChannel.key;
        payload.asin_id = tempInputSearchKey;
        url = "/api/v2/spider/lqsstatus";
      } else {
        url = "/api/v2/spider/flipkart_lqs_request";
        payload.fsn_id = tempInputSearchKey;
      }
      self.$http
        .post(url, payload)
        .then((response) => {
          if (Object.keys(response.data.data).length) {
            if (this.selectedChannel.key == "flipkart.com") {
              self.viewFlipkartLQSCardData = response.data.data.data;
              this.storeLqsDataByMonthGroup = null;
              this.storeLqsDataByMonthGroup = this.sortAndGroupByMonth(
                response.data.data.data.slice(1)
              );
              this.$refs.childComp.gaugeChart(response.data.data.data[0].total);
              this.changeTableData();
              self.loader = false;
            } else {
              self.viewLqsListingdata = response.data.data.data;
              this.storeLqsDataByMonthGroup = null;
              this.storeLqsDataByMonthGroup = this.sortAndGroupByMonth(
                response.data.data.data.slice(1)
              );
              this.$refs.childComp.gaugeChart(response.data.data.data[0].total);
              this.changeTableData();
              self.loader = false;
            }
          }
          self.loader = false;
        })
        .catch((err) => {
          self.loader = false;
          this.$bvToast.toast("Technical Error!", {
            title: "Error!",
            autoHideDelay: 3000,
            variant: "danger",
          });

          console.log("err");
        });
    },

    //imp
    // updateButtonVisibility(isVisible) {
    //     this.showCompareButton = isVisible;
    // },

    // imp
    compareAsinIdButtonProduct() {
      this.compareAsinIdButton();
    },

    // imp
    sortAndGroupByMonth(data) {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      data.forEach((item) => {
        const date = new Date(item.timestamp);
        item.monthIndex = date.getMonth();
      });
      data.sort((a, b) => a.monthIndex - b.monthIndex);
      const groupedData = {};
      data.forEach((item) => {
        const monthName = monthNames[item.monthIndex];
        if (!groupedData[monthName]) {
          groupedData[monthName] = [];
        }
        groupedData[monthName].push(item);
      });
      return groupedData;
    },

    // imp
    chartHeight() {
      if (window.screen.width < 1400) {
        return 200;
      } else return 250;
    },

    // imp
    chartSize() {
      if (window.screen.width < 1400) {
        return 280;
      } else return 400;
    },

    // imp
    gaugeChart() {
      let self = this;
      this.gaugeChartData = {
        chart: {
          type: "gauge",
          plotBackgroundImage: null,
          height: this.chartHeight(),
        },

        title: {
          text: "Listing Quality Score ",
        },
        credits: {
          enabled: false,
        },
        pane: [
          {
            startAngle: -45,
            endAngle: 45,
            background: null,
            center: ["50%", "120%"],
            size: this.chartSize(),
          },
        ],

        exporting: {
          enabled: false,
        },

        tooltip: {
          enabled: false,
        },

        yAxis: [
          {
            min: 0,
            max: 10,
            minorTickPosition: "outside",
            tickPosition: "outside",
            labels: {
              rotation: "auto",
              distance: 10,
            },
            plotBands: [
              {
                from: 0,
                to: 10,
                color: {
                  stops: [
                    [0, "#fd6b2d"], //yellow
                    [1, "#55BF3B"], //green
                  ],
                },
                innerRadius: "90%",
                outerRadius: "100%",
              },
              {
                from: 0,
                to: 4,
                color: "#FF786B", // red
                thickness: 20,
              },
              {
                from: 4,
                to: 8,
                color: "#667BFE", // blue
                thickness: 20,
              },
              {
                from: 8,
                to: 10,
                color: "#42D9BC", // green
                thickness: 20,
              },
            ],
            pane: 0,
            title: {
              text: "",
              y: 0,
            },
          },
        ],

        plotOptions: {
          gauge: {
            dataLabels: {
              enabled: false,
            },
            dial: {
              radius: "100%",
            },
          },
        },

        series: [
          {
            name: "Ratting",
            data: [self.viewLqsGraph],
            yAxis: 0,
          },
        ],
      };
    },

    // corrected
    deleteLQSProductApi() {
      let self = this;
      self.deleteProductLoader = true;
      self.disableDeleteProductBtn = true;
      let payload = {
        product_id: this.storeDeleteProductId,
        channel: this.storeDeleteChannelName,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      const url = "/api/v2/spider/delete_requested_ids";
      self.$http
        .post(url, payload)
        .then((response) => {
          self.deleteProductLoader = false;
          $("#MyasinTable").DataTable().destroy();
          self.getMyASINsData();
          self.deleteProductRowModal = false;
          self.disableDeleteProductBtn = false;
          self.storeDeleteProductId = "";
          self.storeDeleteChannelName = "";
          this.$bvToast.toast(response.data.data.message, {
            title: response.data.data.summary,
            autoHideDelay: 3000,
            variant: "success",
          });
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    confirmDeleteProductsRow(productId, channelUrl) {
      if (productId != null) {
        let getChannelName = channelUrl.split(".")[1];
        this.storeDeleteProductId = "";
        this.storeDeleteChannelName = "";
        this.storeDeleteProductId = productId;
        this.storeDeleteChannelName = getChannelName;
        this.deleteProductRowModal = true;
      } else {
        alert("product ID shouldn't be Empty!");
      }
    },
    closeConfirmRowModal() {
      this.deleteProductRowModal = false;
      this.storeDeleteProductId = "";
      this.storeDeleteChannelName = "";
    },

    compareAsinIdButton() {
      this.checkboxIndices.forEach((items) => {
        if (typeof items === "object") {
          if (this.selectedChannel.key == "flipkart.com") {
            this.compareAsinIds.push(items.product_fsn);
            this.$router.push({
              path: `/fsns-compare/${JSON.stringify(this.compareAsinIds)}/${
                this.dateRange.startDate
              }/${this.dateRange.endDate}`,
            });
          }
        
        else{
          this.compareAsinIds.push(items.product_asin);
            this.$router.push({
              path: `/asins-compare/${this.selectedChannel.key}/${JSON.stringify(this.compareAsinIds)}/${
                this.dateRange.startDate
              }/${this.dateRange.endDate}`,
            });
        }       
        }
        
      });
    },

    checkButtonVisible() {
      return this.checkboxIndices.length >= 4;
    },

    setIndex(index, row) {
      if (this.checkboxIndices.includes(index)) {
        this.checkboxIndices.splice(this.checkboxIndices.indexOf(index), 2);
      } else this.checkboxIndices.push(index, row);
    },

    getMyASINsData() {
      let self = this;
      if ($.fn.DataTable.isDataTable("#MyasinTable")) {
        $("#MyasinTable").DataTable().destroy();
      }

      self.productTableLoader = true;
      self.asinProductTableDataShow = false;
      self.viewMyASINsData = {};
      let payload = {
        start: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        client: this.customClient,
        category: this.selectedCategoryForLqs.key,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      if (this.selectedChannel.key != "flipkart.com") {
        payload.channel = this.selectedChannel.key;
      }
      let url = "/api/v2/spider/viewasincount";

      if (this.selectedChannel.key == "flipkart.com") {
        url = "/api/v2/spider/viewfsncount";
      }
      self.$http
        .post(url, payload)
        .then((response) => {
          // console.log(response.data.data_present, 'lqs')
          self.asinProductTableDataShow = response.data.data_present;
          if (Object.keys(response.data.data).length) {
            self.viewMyASINsData = response.data.data;
            self.productTableLoader = false;
          }
          self.$nextTick(() => {
            $("#MyasinTable").dataTable();
            $("#MyasinTable").DataTable().destroy();
            $("#MyasinTable").DataTable({
              autoWidth: false,
              sorting: true,
              rowReorder: true,
              columnDefs: [
                { orderable: true, className: "reorder", targets: 5 },
                { orderable: false, targets: "_all" },
              ],
              language: {
                search: "",
                paginate: {
                  first: "",
                  previous: "<",
                  next: ">",
                  last: "",
                },
                // lengthMenu: "<h5>Show entries</h5> _MENU_",
              },
              pagingType: "full_numbers",
              order: [],
            });
            let search = require("../../../public/Icons_SVG/Search.svg");
            $("#MyasinTable_filter > label > input").attr(
              "placeholder",
              "Search"
            );
            $("#MyasinTable_filter > label").append(
              `<div><img src='${search}' width='20'/></div>`
            );
            $("#MyasinTable_length > label > select").removeClass();

            var btn = $(
              '<input type="button" class="btn downloadBtn" value="Export" id="downloadBtn"/>'
            );
            $("#MyasinTable_filter > label").append(btn);
            $("#downloadBtn").click(() => {
              this.downloadStandardExel();
            });
          });
          self.productTableLoader = false;
        })
        .catch((err) => {
          self.productTableLoader = false;
          console.log("err", err);
          self.asinProductTableDataShow = false;
        });
    },

    getAllCategoryOption() {
      if (
        !this.translatedLang ||
        !this.selectedLanguage ||
        !this.translatedLang["All Categories"]
      ) {
        return {
          key: "",
          value: "All Categories",
        };
      }

      return {
        key: "",
        value:
          this.translatedLang["All Categories"][this.selectedLanguage.key] ||
          "All Categories",
      };
    },

    downloadStandardExel() {
      let self = this;
      self.loader = true;
      let payload = {
        start: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        client: this.customClient,
        // channel: this.selectedChannel,
        category: this.selectedCategoryForLqs.key,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      if (this.selectedChannel.key != "flipkart.com") {
        payload.channel = this.selectedChannel.key;
      }
      let url = "/api/v2/spider/export/viewasincount";

      if (this.selectedChannel.key == "flipkart.com") {
        url = "/api/v2/spider/export/viewfsncount";
      }
      self.$http
        .post(url, payload)
        .then((response) => {
          window.location = response.body.data;
          self.loader = false;
        })
        .catch((err) => {
          console.log(err);
          self.loader = false;
        });
    },

    showBreakdownModalFun(getValue, data, index, e) {
      this.storeShowBreakdownIndex = index;
      this.storeBreakdownDataInModal = data;
      if (getValue == "mousein") {
        const boundingRect = e.target.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const popupHeight = 200;
        const shouldShowAbove =
          boundingRect.bottom + popupHeight > viewportHeight - 100;
        this.popupStyles = {
          position: "absolute",
          top: shouldShowAbove
            ? `${boundingRect.top + window.scrollY - popupHeight - 70}px`
            : `${boundingRect.bottom + window.scrollY + 10}px`,
          left: `${boundingRect.left + window.scrollX + 700}px`,
          transform: "translateX(-50%)",
          zIndex: "9999",
          opacity: 0,
          transition: "all 0.4s ease-in-out",
        };

        this.showBreakdownModalValue = true;
        setTimeout(() => {
          this.popupStyles.opacity = 1;
        }, 1500);
      } else if (getValue == "mouseout") {
        this.popupStyles.opacity = 0;
        setTimeout(() => {
          this.showBreakdownModalValue = false;
        }, 10);
      }
    },

    changeLqsCategory() {
      sessionStorage.setItem(
        "lqsCategoryValue",
        JSON.stringify(this.selectedCategoryForLqs)
      );
      this.changeTableData();
    },

    // changeTableData() {
    // 	$("#MyasinTable").DataTable().destroy();
    // 	this.getMyASINsData();
    // },
  },

  // imp
  watch: {
    selectedChannel: {
      handler() {
        this.viewFlipkartLQSCardData = [];
        this.viewLqsListingdata = [];
        this.checkboxIndices = [];
        this.compareAsinIds = [];
      },
      deep: true,
    },
    selectedCategoryForLqs: {
      handler() {
        this.viewFlipkartLQSCardData = [];
        this.viewLqsListingdata = [];
        this.checkboxIndices = [];
        this.compareAsinIds = [];
      },
      deep: true,
    },

    // selectedChannel: {
    //     handler(newValue) {
    //         this.changeTableData();
    //         sessionStorage.setItem("productSelectedChannel", JSON.stringify(newValue));
    //         this.checkboxIndices = [];
    //         this.compareAsinIds = [];
    //         this.viewFlipkartLQSCardData = [];
    //         this.viewLqsListingdata = [];
    //     },
    //     deep: true,
    // },
  },
};
</script>

<style scoped>
select option {
  text-transform: capitalize;
  padding: 10px 0px;
}

select {
  font-family: "Poppins", sans-serif;
}

.customSelect select {
  border: 1px solid rgb(228, 231, 234) !important;
  height: 35px;
  border-radius: 5px !important;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

.screenshot-btn {
  transition: 0.4s linear !important;
  cursor: pointer;
}

.cursor-pointer {
  cursor-pointer: pointer !important;
}

.screenshot-btn .fa-download {
  color: var(--primary_brand) !important;
}

.screenshot-btn:hover {
  background-color: #f2f1f6;
}

.screenshot-hide-btn {
  visibility: hidden;
}

.space-between {
  display: flex;
  justify-content: space-between;
}

.flex-start {
  display: flex;
  justify-content: start;
}

.mainHeading {
  color: #4e4e4e;
  margin-bottom: 0;
  font-size: 1.3125rem;
}

.secondaryHeading {
  color: #4e4e4e;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: bold;
}

.textColor {
  color: #818890 !important;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.inputBox {
  height: 30px;
  border: 1px solid silver;
  display: flex;
  justify-content: start;
  background: white;
}

.inputBox input {
  border-radius: 0px;
  border: none !important;
}

.sideBorder {
  border-right: 1px solid #c1c1c1;
}

input:focus {
  outline: none !important;
  box-shadow: none !important;
}

.trueIcon {
  color: #64ac94 !important;
}

.falseIcon {
  color: #ff0000 !important;
}

.errorMassage {
  color: #ff0000 !important;
  font-family: "poppins";
  font-size: 11px;
  margin-top: 5px;
}

.cardButton {
  margin-left: 10px;
}

.productCart {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

.productImg {
  width: 200px;
}

.product-title {
  font-size: 18px;
}

.productImg img {
  width: 100%;
}

.graphCount {
  font-size: 24px;
  color: "#533a79";
  font-weight: 700;
}

.asinBadge {
  /* background: '#9683b3'; */
  background: "#9683b3";
}

.cross-icon {
  color: black;
  background: white;
}

.crossIcon {
  cursor: pointer;
  font-size: 8px;
}

.space-between {
  display: flex;
  justify-content: space-between;
}

thead {
  font-family: "poppins" !important;
  background: var(--background) !important;
  color: #4e4e4e !important;
  font-size: 14px;
  font-weight: bold;
  /* padding: 10px; */
  color: black;
}

tbody {
  font-family: "poppins" !important;
  font-size: 13px;
}

.pinkColor {
  background: rgb(255 185 185);
  font-weight: bold;
}

.skyColor {
  background: rgb(199 224 255);
  font-weight: bold;
}

.no-data {
  font-size: 16px;
  text-align: center;
  padding: 10px;
  color: var(--red);
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 18px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

.customInput {
  border-radius: 5px !important;
  height: 35px !important;
  border: 1px solid rgb(228, 231, 234);
  width: 220px;
  outline: none;
}

.danger {
  border: 1px solid var(--red);
  color: var(--red) !important;
  height: 35px !important;
  width: 220px;
  background-color: var(--red-20);
  border-radius: 5px !important;
}

.danger:focus {
  border: 1px solid var(--red) !important;
}

.customInput:focus {
  border: 1px solid var(--primary_brand) !important;
}

.customInput::placeholder {
  color: var(--primary_brand-40);
}

#lqsTable {
  --border: 1px solid var(--base_color-20);
  border-radius: 10px;
  border-spacing: 0;
  border-collapse: separate;
  border: var(--border);
  overflow: hidden;
}

#lqsTable th:not(:last-child),
#lqsTable td:not(:last-child) {
  border-right: var(--border) !important;
}

#lqsTable > tbody > tr:not(:last-child) > td {
  border-bottom: var(--border) !important;
}

#lqsTable th {
  background: var(--background);
  padding: 0.6rem !important;
  font-size: 14px !important;
  border-bottom: var(--border) !important;
  font-family: "Poppins", sans-serif !important;
}

#lqsTable td {
  padding: 4px !important;
  font-size: 14px !important;
  font-family: "Heebo", sans-serif !important;
}

.singatureLogo {
  position: absolute;
  bottom: 20px;
  right: 20px;
  text-align: center !important;
}

.delete-alert {
  background-color: #ffecec !important;
  color: var(--red);
  font-size: 30px;
  width: 45px;
  height: 45px;
}

.delete-requestBtn:hover {
  background-color: #f58181 !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
/* modal */
/* .modal-title {
    font-weight: 400 !important;
	font-family: "poppins" !important;
	border-bottom: 1px solid #D5D5D5 !important;
	padding-bottom: 15px;
	color: #5E5E5E !important;
	font-size: 16px;
}

.modal-header {
    background: var(--primary_brand-20) !important;
    color: var(--base_color);
    border: none;
    font-family: "poppins";
    border-radius: 5px 0px 0px 0px !important;
}

.modal-header .close {
    color: black !important;
    text-shadow: none !important;
    position: absolute !important;
    top: -2px;
    right: -6px;
    font-size: 30px;
    background: var(--primary_brand-10);
    opacity: inherit;
    padding: 5px 10px;
    border-radius: 25px;
} */

.modal-delete-content {
  color: var(--primary_brand);
  font-size: 16px;
  margin-bottom: 5px;
  font-family: "poppins";
}

.btn-outline-danger:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: red !important;
}

button.primarycolor.scheduleBg {
  color: var(--primary_brand) !important;
  background: #fff;
  outline: 1px solid var(--primary_brand);
}

button.primarycolor.scheduleBg:hover {
  color: #fff !important;
  background-color: var(--primary_brand) !important;
  outline: 1px solid var(--primary_brand);
}

button.primarycolor.scheduleBg:focus {
  box-shadow: none !important;
  border-color: none !important;
  outline: 0 !important;
}

.labelHeading {
  font-size: 14px !important;
  color: #000;
  margin-bottom: 8px;
}

.containerOverflowClass {
  width: 99.7% !important;
  overflow-x: visible !important;
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white !important;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

/* #LqsAnalyser .vue-daterange-picker .reportrange-text {
    border: 1px solid #ddd !important;
} */

.form-control {
  font-size: 12px !important;
}

button.primarycolorShow {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 6px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: 100;
  font-size: 14px;
}

button.primarycolorShow2 {
  background-color: #fff;
  color: #065559;
  border: 1px solid #065559;
}

button.primarycolorShow:hover {
  color: white;
  background: var(--primary_brand-80);
}

.productNameHeading {
  border-bottom: 1px solid #eae9e9;
  font-size: 16px;
  color: #065559;
}

.productName {
  color: #5a5a5a;
  text-align: center;
}

/* table */
#MyasinTable_filter .downloadBtn {
  margin: 0px 10px;
  height: 35px;
  width: 100px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px !important;
  font-weight: 600;
  padding: 0px !important;
  letter-spacing: 0.2px;
}
</style>
<style>
#MyasinTable_filter > label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#MyasinTable_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#MyasinTable_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#MyasinTable_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#MyasinTable_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#MyasinTable_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#MyasinTable .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

#MyasinTable_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#MyasinTable_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

#MyasinTable_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}

#MyasinTable_info {
  position: relative;
  top: 9px;
  /* left: 324px; */
  z-index: 100;
  /* float: right; */
  width: 50vw;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#MyasinTable_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#MyasinTable_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#MyasinTable_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 0px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
  /* cursor: pointer !important; */
}

#MyasinTable_length select:focus-visible {
  box-shadow: none !important;
  outline: none !important;
}

#MyasinTable_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#MyasinTable_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#MyasinTable {
  border-radius: 0 0 0 0 !important;
}

#MyasinTable .thead-normal,
#MyasinTable .thead-normal tr:first-child,
#MyasinTable .thead-normal > tr:first-child > th:first-child {
  /* background-color: var(--background) !important; */
  background-color: none !important;
  background: #0655590a !important;
  border-radius: 0 0 0 0 !important;
  border-left: 1px solid var(--base_color-20) !important;
}

#MyasinTable .thead-normal > tr:last-child > th:first-child {
  /* border-left: 1px solid var(--base_color-20) !important; */
  border-left: none !important;
}

#MyasinTable .thead-normal > tr:first-child > th:last-child {
  border-radius: 0 0 0 0 !important;
}

#MyasinTable .thead-normal > tr:first-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 600 !important;
  text-align: center !important;
  padding: 5px 25px 0px 25px !important;
  color: #5e5e5e !important;
  /* border-top: 1px solid var(--base_color-20) !important; */
  /* border-right: 1px solid var(--base_color-20) !important; */
  border-top: none !important;
  border-right: none !important;
}

#MyasinTable .thead-normal > tr:last-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 600 !important;
  text-align: center !important;
  padding: 5px 25px 5px 25px !important;
  color: #5e5e5e !important;
  /* border-right: 1px solid var(--base_color-20) !important; */
  border-right: none !important;
  font-family: "Poppins", sans-serif !important;
}

#MyasinTable .thead-normal > tr > th.sorting:before {
  font-size: 12px !important;
  bottom: 60% !important;
  color: var(--base_color-80);
}

#MyasinTable .thead-normal > tr > th.sorting:after {
  font-size: 12px;
  top: 50%;
  color: var(--base_color-80);
}

#MyasinTable th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#MyasinTable tfoot th {
  /* background-color: var(--background) !important; */
  background-color: #fff !important;
  /* border-right: 1px solid var(--base_color-20) !important; */
  border-bottom: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#MyasinTable tfoot th:first-child {
  /* background-color: var(--background) !important; */
  background-color: #fff !important;
  border-left: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#MyasinTable tbody td {
  border-bottom: 1px solid var(--base_color-20) !important;
  /* border-right: 1px solid var(--base_color-20) !important; */
  font-size: 14px !important;
  font-family: "Heebo" !important;
}

#MyasinTable tbody td:first-child {
  /* border-left: 1px solid var(--base_color-20) !important; */
  border-left: none !important;
}

#MyasinTable .even td {
  background: #fff !important;
}

#MyasinTable .odd td {
  background: #fff !important;
  /* filter: brightness(110%); */
}

#MyasinTable_wrapper > .row:last-child {
  margin-bottom: 15px;
}

#MyasinTable_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#MyasinTable_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#MyasinTable_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#MyasinTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--base_color-40);
}

#MyasinTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 4px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

#MyasinTable input[type="checkbox"]:checked {
  background-color: var(--primary_brand) !important;
  accent-color: var(--primary_brand) !important;
}

#MyasinTable input[type="checkbox"]:hover {
  cursor: pointer;
}

table.dataTable#MyasinTable td,
table.dataTable#MyasinTable th {
  border-right: none !important;
}

table.dataTable#MyasinTable th {
  background-color: #0655590a !important;
}

/* table.dataTable#MyasinTable td:last-child, table.dataTable#MyasinTable th:last-child {
    border-right: 1px solid #D5D5D5 !important;
} */

table.dataTable#MyasinTable th:first-child {
  border-left: none !important;
}

#MyasinTable_wrapper .row:nth-child(2) {
  border: 1px solid #d5d5d5 !important;
  margin: 10px 0 0 0 !important;
  padding-bottom: 14px !important;
  border-radius: 7px;
}

#MyasinTable .dataTables_empty {
  color: var(--red);
}

.bgInfoColor {
  color: #818181;
}

#MyasinTable table.dataTable {
  margin-top: 0;
  padding-top: 6px !important;
}

#MyasinTable_wrapper .row:nth-child(2) .col-sm-12 {
  padding: 0 !important;
}

#MyasinTable_wrapper table.dataTable {
  margin-top: 0 !important;
}

.noData {
  border: 1px solid #fbb1b1;
  border-radius: 5px;
  padding: 10px;
  background: #fff7f7;
}

.noDataBreak {
  /* background: #fff7f7; */
  font-size: 12px;
  color: var(--primary-brand);
}

/* #MyasinTable thead>tr>th.sorting_asc:before, #MyasinTable thead>tr>th.sorting_asc::after{
	display: none !important;
} */

.compareBtnProduct button {
  font-size: 14px !important;
}

.container-breakdown-ASIN {
  /* position: fixed;
	top: 70%;
	left: 50%;
	transform: translate(-50%, -70%);
	z-index: 99999999999999 !important; */
  background: white;
  box-shadow: 0px 4px 4px 0px #00000040;
  border: 1px solid #ebebeb;
  border-radius: 10px !important;
  width: 60%;
}

.breakdownLablesRed h5,
.breakdownLablesRed p {
  color: #8c0000;
}

.checkIconBreakdown {
  background-color: #50b767 !important;
}

.crossIconBreakdown {
  background-color: #8c0000 !important;
}

.container-breakdown-ASIN p,
.breakdownLablesRed h5,
.breakdownLablesRed p,
.breakdownLables h5,
.breakdownLables p {
  font-size: 12px !important;
}

.customWidth-33 {
  width: 33%;
}

.mediaBreakdownData {
  border-left: 1px solid #d4d4d4;
  border-right: 1px solid #d4d4d4;
  min-height: 100%;
}

.blur {
  /* filter: blur(2px); */
  pointer-events: none;
  color: #5e5e5e !important;
}

.unblur {
  /* filter: none; */
  font-weight: 600 !important;
  pointer-events: auto;
  color: var(--primary_brand) !important;
}

/* #MyasinTable_filter .downloadBtn {
	margin: 0px 10px;
	height: 35px;
	width: 100px;
	border: none;
	background: var(--primary_brand);
	color: white;
	border-radius: 5px !important;
	font-weight: 600;
	padding: 0px !important;
	letter-spacing: 0.2px;
} */
</style>
